import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/page/login'
import Manage from '@/page/manage'
import UserList from '@/page/userList'
import AddShop from '@/page/addShop'
import Materrial from '@/page/materrial'
import AddGoods from '@/page/addGoods'
import NewCurriculum from '@/page/newCurriculum'
import ShopList from '@/page/shopList'
import OrderList from '@/page/orderList'
import PatFication from '@/page/patFication'
import PatMagent from '@/page/patMagent'
import TypeMagent from '@/page/typeMagent'
import TypeTitle from '@/page/typeTitle'
import Explain from '@/page/explain'
import Intuser from '@/page/intuser'
import Management from '@/page/management'
import Classification from '@/page/classification'
import NewCourse from '@/page/newCourse'
import Course from '@/page/course'
import AddText from '@/page/addText'
import Courseification from '@/page/courseification'
import IntuserDetail from '@/page/intuserDetail'
import ModCurriculum from '@/page/modCurriculum'
import ModCourse from '@/page/modCourse'
import ModGoods from '@/page/modGoods'
import NewCourseification from '@/page/newCourseification'
import ModCourseification from '@/page/modCourseification'
import Subdirectory from '@/page/subdirectory'
import Subdirectoryhot from '@/page/subdirectoryhot'
import MaterialInfo from '@/page/materialInfo'
import User from '@/page/user'
import Financial from '@/page/financial'
import Trialcourse from '@/page/trialcourse'
import NewTrialCourse from '@/page/newTrialCourse'
import ModTrialCourse from '@/page/modTrialCourse'
import Remarks from '@/page/remarks'
import Privilege from '@/page/privilege'
import Account from '@/page/account'
import Newprivilege from '@/page/newprivilege'
import Modprivilege from '@/page/modprivilege'
import Empty from '@/page/empty'
import DataCenter from '@/page/dataCenter'
import Group from '@/page/group'
import Addgroup from '@/page/addgroup'
import Order from '@/page/order'
import Seegroup from '@/page/seegroup'
import Orders from '@/page/orders'
import Channel from '@/page/channel'
import Reflect from '@/page/reflect'
import Feedback from '@/page/feedback'
import Feeddetail from '@/page/feeddetail'
import Institution from '@/page/institution'


import store from '../store/store'
Vue.use(Router)

const routes = [
  {
    path: '/',
    component: Login
  },
  {
    path: '/manage',
    component: Manage,
    children: [
      {
        path: '',
        component: UserList,
        meta: [],
      },{
        path: '/addShop',
        component: AddShop,
        meta: ['热门专题', '课程分类'],
      },{
        path: '/materrial',
        component: Materrial,
        meta: ['热门专题','文字素材'],
      },{
        path: '/addGoods',
        component: AddGoods,
        meta: ['兑换商城', '新增商品'],
      },{
        path: '/modGoods',
        component: ModGoods,
        meta: ['兑换商城', '编辑商品'],
      },{
        path: '/newCurriculum',
        component: NewCurriculum,
        meta: ['单体画法','课程管理','添加课程'],
      },{
        path: '/modCurriculum',
        component: ModCurriculum,
        meta: ['单体画法','课程管理','编辑课程'],
      },{
        path: '/userList',
        component: UserList,
        meta: ['单体画法', '课程管理'],
      },{
        path: '/shopList',
        component: ShopList,
        meta: ['单体画法', '课程分类'],
      },{
        path: '/subdirectory',
        component: Subdirectory,
        meta: ['单体画法', '子目录'],
      },{
        path: '/patFication',
        component: PatFication,
        meta: ['手抄报创作', '图案分类'],
      },{
        path: '/patMagent',
        component: PatMagent,
        meta: ['手抄报创作', '图案管理'],
      },{
        path: '/typeMagent',
        component: TypeMagent,
        meta: ['手抄报创作', '排版管理'],
      },{
        path: '/typeTitle',
        component: TypeTitle,
        meta: ['手抄报创作', '标题管理'],
      },{
        path: '/management',
        component: Management,
        meta: ['兑换商城', '商品管理'],
      },{
        path: '/classification',
        component: Classification,
        meta: ['兑换商城', '商品分类'],
      },{
        path: '/orderList',
        component: OrderList,
        meta: ['兑换商城', '订单管理'],
      },{
        path: '/explain',
        component: Explain,
        meta: ['机构管理', '机构申请'],
      },{
        path: '/intuser',
        component: Intuser,
        meta: ['机构管理', '合作机构'],
      },{
        path: '/intuserDetail',
        component: IntuserDetail,
        meta: ['机构管理', '机构用户', '机构详情'],
      },{
        path: '/newCourse',
        component: NewCourse,
        meta: ['如何创作','添加课程'],
      },{
        path: '/modCourse',
        component: ModCourse,
        meta: ['如何创作','编辑课程'],
      },{
        path: '/course',
        component: Course,
        meta: ['如何创作'],
      },{
        path: '/addText',
        component: AddText,
        meta: ['课题大全','文字素材','添加素材'],
      },{
        path: '/materialInfo',
        component: MaterialInfo,
        meta: ['课题大全','文字素材','编辑'],
      },{
        path: '/courseification',
        component: Courseification,
        meta: ['课题大全','课程分类'],
      },{
        path: '/subdirectoryhot',
        component: Subdirectoryhot,
        meta: ['课题大全','子目录'],
      },{
        path: '/newCourseification',
        component: NewCourseification,
        meta: ['课题大全','课程管理','添加课程'],
      },{
        path: '/modCourseification',
        component: ModCourseification,
        meta: ['课题大全','课程管理','编辑课程'],
      },{
        path: '/user',
        component: User,
        meta: ['用户管理'],
      },{
        path: '/financial',
        component: Financial,
        meta: ['财务数据'],
      },{
        path: '/trialcourse',
        component: Trialcourse,
        meta: ['试看课程'],
      },{
        path: '/newTrialCourse',
        component: NewTrialCourse,
        meta: ['试看课程','新增课程'],
      },{
        path: '/modTrialCourse',
        component: ModTrialCourse,
        meta: ['试看课程','编辑课程'],
      },{
        path: '/remarks',
        component: Remarks,
        meta: ['财务数据'],
      },{
        path: '/privilege',
        component: Privilege,
        meta: ['后台权限','权限管理'],
      },{
        path: '/account',
        component: Account,
        meta: ['后台权限','账号管理'],
      },{
        path: '/newprivilege',
        component: Newprivilege,
        meta: ['后台权限','权限管理','新增角色'],
      },{
        path: '/modprivilege',
        component: Modprivilege,
        meta: ['后台权限','权限管理','编辑角色'],
      },{
        path: '/empty',
        component: Empty,
      },{
        path: '/dataCenter',
        component: DataCenter,
        meta: ['数据中心'],
      },{
        path: '/group',
        component: Group,
        meta: ['团购管理'],
      },{
        path: '/addgroup',
        component: Addgroup,
        meta: ['团购管理','新增团购'],
      },{
        path: '/order',
        component: Order,
        meta: ['团购订单'],
      },{
        path: '/seegroup',
        component: Seegroup,
        meta: ['团购详情'],
      },{
        path: '/orders',
        component: Orders,
        meta: ['团购管理','团购订单'],
      },{
        path: '/channel',
        component: Channel,
        meta: ['渠道管理'],
      },{
        path: '/reflect',
        component:Reflect,
        meta: ['提现申请'],
      },{
        path: '/feeddetail',
        component:Feeddetail,
        meta: ['问题反馈','反馈详情'],
      },{
        path: '/feedback',
        component:Feedback,
        meta: ['问题反馈'],
      },{
        path: '/institution',
        component:Institution,
        meta: ['合作机构','机构用户'],
      }]
  }
]
if (sessionStorage.getItem('token')) {
  store.commit('set_token', sessionStorage.getItem('token'))
}

const router = new Router({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {   //这里的requireAuth为路由中定义的 meta:{requireAuth:true}，意思为：该路由添加该字段，表示进入该路由需要登陆的
    if (store.state.token) {
      next();
    }
    else {
      next({
        path: '/',
        query: {redirect: to.fullPath}
      })
    }
  }
  else {
    next();
  }
})
export default new Router({
  routes,
  strict: process.env.NODE_ENV !== 'production',
})





// WEBPACK FOOTER //
// ./src/router/index.js